const FIELD_PATTERNS = {
  unit: ['unit', 'unit #', 'unit number', 'unit no', 'apt', 'apt #', 'apartment', 'apartment number', 'space', 'suite', 'bldg/unit'],
  name: ['tenant', 'tenant name', 'resident', 'resident name', 'name', 'full name', 'lessee', 'occupant', 'renter'],
  monthlyRent: ['rent', 'monthly rent', 'rent amount', 'charge amount', 'market rent', 'lease rent', 'contract rent', 'monthly charge', 'scheduled rent'],
  currentBalance: ['balance', 'balance due', 'amount due', 'amount owed', 'outstanding', 'total due', 'total balance', 'delinquent amount', 'past due', 'arrears', 'current balance'],
  phone: ['phone', 'phone number', 'cell', 'mobile', 'contact number', 'cell phone', 'primary phone', 'telephone', 'tel'],
  email: ['email', 'email address', 'e-mail', 'contact email', 'e mail'],
  preferredLanguage: ['language', 'preferred language', 'lang', 'language preference'],
};

const FIELD_EXCLUSIONS = {
  unit: ['sq ft', 'square feet', 'square foot', 'unit type', 'floor plan', 'bedroom', 'bathroom', 'market unit'],
  name: ['tenant id', 'resident id', 'customer id', 'account id', 'account number', 'code'],
};

function normalizeFieldName(value) {
  return String(value || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ');
}

export function detectUploadField(columnName) {
  const normalized = normalizeFieldName(columnName);
  const normalizedTokens = normalized.split(' ').filter(Boolean);

  if (!normalized) {
    return 'skip';
  }

  if (['resident', 'tenant', 'occupant', 'lessee'].includes(normalized)) {
    return 'skip';
  }

  for (const [field, patterns] of Object.entries(FIELD_PATTERNS)) {
    const exclusions = FIELD_EXCLUSIONS[field] || [];
    const excluded = exclusions.some((pattern) => normalized.includes(normalizeFieldName(pattern)));
    if (excluded) {
      continue;
    }

    for (const pattern of patterns) {
      const normalizedPattern = normalizeFieldName(pattern);
      if (!normalizedPattern) {
        continue;
      }

      const patternTokens = normalizedPattern.split(' ').filter(Boolean);

      if (normalized === normalizedPattern) {
        return field;
      }

      const patternTokensPresent = patternTokens.every((token) => normalizedTokens.includes(token));
      const headerTokensPresent = normalizedTokens.every((token) => patternTokens.includes(token));

      if (patternTokensPresent || headerTokensPresent) {
        return field;
      }
    }
  }

  return 'skip';
}
